<template>
    <v-container>
        <v-row>
            <v-col
            xs="12"
            >
                <v-card>
                    <v-card-title class="headline">Criar Sessão</v-card-title>
                    <v-simple-table>
                        <thead>
                        <th class="text-center">Loja</th>
                        <th class="text-center">Ação</th>
                        </thead>

                        <tbody>
                            <tr v-for=" store in $store.state.stores" :key="store.id">
                                <td>{{store.name}}</td>
                                <td class="text-center">
                                    <v-dialog
                                        transition="dialog-bottom-transition"
                                        max-width="600"
                                    >   
                                        <template v-slot:activator="{ on, attrs }">
                                            <div v-if="$store.state.user_plan.id == 1 || $store.state.user_plan.id == 6">
                                                <v-btn
                                                color="primary"
                                                @click="semAutomatizacao"
                                                >Automatizar</v-btn>
                                            </div>
                                            <div v-else>
                                                <v-btn
                                                color="primary"
                                                v-bind="attrs"
                                                v-on="on"
                                                v-if="!store.notifications"
                                                >Automatizar</v-btn>
                                            </div>
                                            
                                        </template>
                                        <template v-slot:default="dialog">
                                        <v-card>
                                            <v-toolbar
                                            color="primary"
                                            dark
                                            >QrCode</v-toolbar>
                                            <v-card-text>                                                
                                                <v-row>
                                                    <v-btn
                                                    class="mt-6"
                                                    text
                                                    name = "conectar"
                                                    @click="connectSession(store.uuid)"
                                                    >
                                                        Conectar
                                                    </v-btn>                                                    
                                                    <!-- <v-btn
                                                    color="primary mt-6"
                                                    @click="getQrcode(store.uuid)"
                                                    >
                                                    Gerar QrCode
                                                    </v-btn>                                                     -->
                                                </v-row>
                                                <br>
                                                <!-- <v-row>
                                                    <div class="container justify-center mb-6">
                                                        <div>
                                                            <img  :src="qrcode">
                                                        </div>
                                                    </div >                                                    
                                                </v-row> -->
                                            </v-card-text>
                                            <v-card-actions class="justify-end">
                                            <v-btn
                                                text
                                                @click="dialog.value = false"
                                            >Fechar</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                        </template>
                                    </v-dialog>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>

</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            loading: false,
            qrcode:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAABvElEQVRIie3WP2gVQRDH8U+itiJY6XuGELVSbBSsrf2XziqV2ihRBLWwtLaxsAgqIoiIlZEEK0uL1IKkkkAeVqJEUZEkPos9yOa42713eWiTHwwcdzP7nZ3bmTu29Y80MoDvGM7jNMbRLe73sIQ5zGJ5WMl1MIM19DO2jpdFYlvSJL43AJbtG861hV4XdjAoNN79tUGhk1uExvDGO+9qV95U2fc3AT+uCP6De7iF3y3gD3PQMdWn937k87QFeM1G+1VquibwSORzsgW4j6sp8JuaoDjbnVhpAZ6PQaMl8ERNQiei67vYncq+RgdT4H01QTdsjNdOCyiZk/1TfakuFz578D7hl2qrWi0nAn/geOHXwbvo2Qeh1ZYS8Ysp8Fwm6084WvjuEMbqAg4V93bhIn5VxG46XGXdzID7+IJTiTVG8LUi7koK3NX88/cIhyvWmKrwX5UZIPCkATi2BaHFbuOV6o/LTA4KlwYE52xFfZtu0oshQtdxtgl0FJ+HCJ1uAiWMxmGV90xTKNwpLbCIB3gmnMwccFU4SNl3Wv69fS6009vCetGzA7gg9PAx7BXK2cNHYUC8LsVs6//rL6OeeiPrPEtuAAAAAElFTkSuQmCC"
        }
    },
    created() {
        this.$store.dispatch('fetchUserPlan');
        this.$store.dispatch('fetchStores'); 
    },
    methods: {        
        // async connectSession(id){ 
        //     document.getElementsByName("conectar")[0].disabled = true;         
        //     await axios.post('/api/start', 
        //     {
        //         session: id
        //     },
        //     {
        //         headers: {
        //             accept: 'application/json'
        //         }
        //     }).then(() => { 
        //         Swal.fire({
        //         title: 'sucesso!',
        //         text: 'Seu aparelho foi conectado com sucesso!\nSeus clientes passarão a receber as notificações automáticas configuradas na sessão "Notificações". \n Em caso de dúvidas, entre em contato com o nosso suporte.',
        //         icon: 'success',
        //         confirmButtonText: 'Legal!'
        //         }).then(function() {
        //             location.reload();
        //         });
        //     }).catch(() => {
        //         Swal.fire({
        //         title: 'erro!',
        //         text: ' Não foi possivel conectar seu celular, por favor, tente novamente ou entre em contato com o suporte.',
        //         icon: 'error',
        //         confirmButtonText: 'ok'
        //         });
        //         document.getElementsByName("conectar")[0].disabled = false;
        //     });
        // },
        async connectSession(id){
            window.open(`https://connect.manyconvert.com/index.html?session=${id}`);
        },
        getQrcode(id){
            setInterval(() => {
                axios.get('/api/getqrcode', 
                {
                    params:{
                        session:id
                    },
                    headers: {
                        accept: 'application/json',
                    }
                }).then((res) => this.qrcode = res.data.qrcode);                
            }, 5000);
            
        },
        semAutomatizacao(){
            Swal.fire({
                title: 'Seu plano não permite essa função!',
                text: 'Apenas usuarios com planos a partir do Basic Convert tem acesso a esta função. Por favor, faça o upgrade do seu plano para poder continuar.',
                icon: 'error',
                confirmButtonText: 'Fazer Upgrade'
            }).then(function() {
                window.open('https://manyconvert.com/basicconvert', '_blank');
            });
        }
    },    
}
</script>

<style>

</style>